import React from 'react';
import { connect } from 'react-redux';

import GrayAutosuggestBox from 'components/callouts/grayAutosuggestBox';
import ZpButton from 'components/zpButton';
import { CPP_SUBPAGES, POPUP_SURVEY_SOURCE } from 'utils/constant';

import CustomTable from '../../components/customTable';
import ColumnDataCell from '../../components/customTable/tableCell/ColumnData';
import { formatCurrencyRevenue, formatNumber, ismobileDevice, openInCurrentTab } from '../../utils';

const columnConfig = {
  companyNameCPS: {
    columnName: 'Company Name',
    isLink: 'toBeIndexed',
    linkUrl: 'companyUrl',
    subDataMobile: 'companyNameFoundedDate',
  },
  companyFoundedDate: {
    columnName: 'Founded Date',
  },
  companyRevenueActualFormatted: {
    columnName: 'Revenue',
    customSortByField: 'companyRevenueActual',
  },
  companyEmployeeSizeActualFormatted: {
    columnName: 'Employee Size',
    customSortByField: 'companyEmployeeSizeActual',
  },
};

class SimilarCompaniesSection extends React.Component {
  constructor(props) {
    super(props);
    const similarCompaniesDataFormatted = this.formatData(props.similarCompanies);
    this.state = {
      similarCompaniesDataFormatted,
      calloutFormData: {},
    };
  }

  formatData = (similarCompanies) => {
    return similarCompanies.map((company) => {
      return {
        ...company,
        companyRevenueActual: company.companyRevenueActual ? company.companyRevenueActual : 0,
        companyEmployeeSizeActual: company.companyEmployeeSizeActual
          ? company.companyEmployeeSizeActual
          : 0,
        companyRevenueActualFormatted: formatCurrencyRevenue(company.companyRevenueActual) || '-',
        formattedMedian: company?.formattedMedian || '-',
        companyEmployeeSizeActualFormatted: company.companyEmployeeSizeActual
          ? formatNumber(company.companyEmployeeSizeActual)
          : '-',
        companyNameFoundedDate: (
          <ColumnDataCell bottom={company.companyFoundedDate} top={company.companyNameCPS} />
        ),
        jobsCountActual:
          isNaN(company.jobsCount) || company.jobsCount === 0 ? 0 : parseInt(company.jobsCount),
        jobsCount:
          isNaN(company.jobsCount) || company.jobsCount === 0
            ? '-'
            : formatNumber(company.jobsCount),
      };
    });
  };

  handleCalloutInputChange = (calloutFormData) => {
    this.setState({
      calloutFormData,
    });
  };

  handleCalloutFormSubmit = () => {
    const { calloutFormData = {} } = this.state;
    const { onOpenMainCppSurvey = () => {} } = this.props;
    const answer = {
      answerCategory: 'location',
      answerData: calloutFormData,
    };
    onOpenMainCppSurvey(POPUP_SURVEY_SOURCE.CPP_HISTORY_SIMILAR_BOX, answer);
  };

  getColumnConfig = () => {
    const { customColumnConfig, cppSubPageName } = this.props;
    let colsToBeReturned = {};
    if (customColumnConfig) {
      colsToBeReturned = customColumnConfig;
    } else {
      let cols = { ...columnConfig };
      if (cppSubPageName === CPP_SUBPAGES.HISTORY) {
        cols.jobsCount = {
          columnName: ismobileDevice() ? 'Jobs' : 'Job Openings',
          isLink: 'displayFlagOfCompanyJobsPage',
          linkUrl: 'jobsPageUrl',
        };
        if (cols.companyRevenueActualFormatted)
          cols.companyRevenueActualFormatted = {
            ...cols.companyRevenueActualFormatted,
            isLink: 'displayFlagOfCompanyRevenuePage',
            linkUrl: 'revenuePageUrl',
          };
      }
      colsToBeReturned = cols;
    }

    if (colsToBeReturned.jobsCount) {
      colsToBeReturned.jobsCount.customSortByField = 'jobsCountActual';
    }

    return colsToBeReturned;
  };

  render() {
    const { similarCompaniesDataFormatted } = this.state;
    const { user, companyNameCPS, onOpenMainCppSurvey, competitorsPageLink } = this.props;
    const isUserLoggedIn = !!(user && user.isLoggedIn);

    return (
      <>
        <h2 className="brandonH2 z-mb-48">{`${companyNameCPS} Similar Companies`}</h2>
        <CustomTable
          columnConfig={this.getColumnConfig()}
          bodyData={similarCompaniesDataFormatted}
          defaultRowsDisplay={10}
          displayRowsPerExpand={10}
          scrollOnMobile
        />

        {competitorsPageLink && (
          <ZpButton
            theme="secondary"
            size="big"
            type="button"
            className="mt-5"
            onClick={() => openInCurrentTab(competitorsPageLink)}
            isAutoWidth
          >
            {`${companyNameCPS} Similar Companies`}
          </ZpButton>
        )}

        {onOpenMainCppSurvey && !isUserLoggedIn && (
          <div className="z-mt-24">
            <GrayAutosuggestBox
              title="Find Jobs from Similar Companies"
              subtitle="Personalize your job search. Where would you like to work?"
              autosuggestCategory="location"
              autosuggestPlaceholder="Enter City or State"
              onAutosuggestChange={this.handleCalloutInputChange}
              onSubmit={this.handleCalloutFormSubmit}
            />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ user }) => {
  return {
    user,
  };
};

export default connect(mapStateToProps)(SimilarCompaniesSection);
